/* eslint-disable */
/* tslint:disable */
/* Do not edit - generated by swagger-typescript-api */

import {
  AppMcpStatusResponseDataResponse,
  Condition,
  ConversationCreateRequest,
  ConversationMessageCreateRequest,
  ConversationMessageResponseCollectionResponse,
  ConversationRenameRequest,
  ConversationResponseCollectionResponse,
  ConversationResponseDataResponse,
  ErrorResponse,
  Sorting,
  YbotAvailabilityResponseDataResponse,
  YdistriDevsMcpStatusResponseDataResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';
export class Ybot<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }
  /**
   * No description
   *
   * @tags Ybot
   * @name AvailabilityList
   * @summary The only ybot endpoint that answers when ybot is unavailable - the dock cannot be gated on the superadmin flag alone.
   * @request GET:/Ybot/Availability
   * @response `200` `YbotAvailabilityResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  availabilityList = (params: RequestParams = {}) =>
    this.http.request<YbotAvailabilityResponseDataResponse, ErrorResponse>({
      path: `/Ybot/Availability`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Ybot
   * @name ConversationsList
   * @request GET:/Ybot/Conversations
   * @response `200` `ConversationResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  conversationsList = (
    query?: {
      projectShortName?: string;
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<ConversationResponseCollectionResponse, ErrorResponse>({
      path: `/Ybot/Conversations`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Ybot
   * @name ConversationsCreate
   * @request POST:/Ybot/Conversations
   * @response `201` `void` Created
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  conversationsCreate = (data: ConversationCreateRequest, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/Ybot/Conversations`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Ybot
   * @name GetYbotConversation
   * @request GET:/Ybot/Conversations/{conversationId}
   * @response `200` `ConversationResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getYbotConversation = (conversationId: string, params: RequestParams = {}) =>
    this.http.request<ConversationResponseDataResponse, ErrorResponse>({
      path: `/Ybot/Conversations/${conversationId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Ybot
   * @name ConversationsPartialUpdate
   * @request PATCH:/Ybot/Conversations/{conversationId}
   * @response `200` `ConversationResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  conversationsPartialUpdate = (
    conversationId: string,
    data: ConversationRenameRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ConversationResponseDataResponse, ErrorResponse>({
      path: `/Ybot/Conversations/${conversationId}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Ybot
   * @name ConversationsDelete
   * @request DELETE:/Ybot/Conversations/{conversationId}
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  conversationsDelete = (conversationId: string, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/Ybot/Conversations/${conversationId}`,
      method: 'DELETE',
      ...params,
    });
  /**
   * No description
   *
   * @tags Ybot
   * @name ConversationsMessagesList
   * @request GET:/Ybot/Conversations/{conversationId}/Messages
   * @response `200` `ConversationMessageResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  conversationsMessagesList = (
    conversationId: string,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<ConversationMessageResponseCollectionResponse, ErrorResponse>({
      path: `/Ybot/Conversations/${conversationId}/Messages`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Ybot
   * @name ConversationsMessagesCreate
   * @request POST:/Ybot/Conversations/{conversationId}/Messages
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  conversationsMessagesCreate = (
    conversationId: string,
    data: ConversationMessageCreateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Ybot/Conversations/${conversationId}/Messages`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Ybot
   * @name ConversationsResetCreate
   * @request POST:/Ybot/Conversations/{conversationId}/Reset
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  conversationsResetCreate = (conversationId: string, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/Ybot/Conversations/${conversationId}/Reset`,
      method: 'POST',
      ...params,
    });
  /**
   * No description
   *
   * @tags YbotMcpAccess
   * @name McpYdistriDevsStatusList
   * @request GET:/Ybot/Mcp/YdistriDevs/Status
   * @response `200` `YdistriDevsMcpStatusResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  mcpYdistriDevsStatusList = (params: RequestParams = {}) =>
    this.http.request<YdistriDevsMcpStatusResponseDataResponse, ErrorResponse>({
      path: `/Ybot/Mcp/YdistriDevs/Status`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags YbotMcpAccess
   * @name McpYdistriDevsLoginCreate
   * @request POST:/Ybot/Mcp/YdistriDevs/Login
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  mcpYdistriDevsLoginCreate = (params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/Ybot/Mcp/YdistriDevs/Login`,
      method: 'POST',
      ...params,
    });
  /**
   * No description
   *
   * @tags YbotMcpAccess
   * @name McpAppStatusList
   * @request GET:/Ybot/Mcp/App/Status
   * @response `200` `AppMcpStatusResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  mcpAppStatusList = (params: RequestParams = {}) =>
    this.http.request<AppMcpStatusResponseDataResponse, ErrorResponse>({
      path: `/Ybot/Mcp/App/Status`,
      method: 'GET',
      format: 'json',
      ...params,
    });
}
